import { pathOr } from 'ramda';

/* This is duplicated */
export const getIdFromQueryParam = (param: string): number => {
  const idString: string = pathOr('', [1])(param.match(/-(\d+)$/))
  return parseFloat(idString)
}
